import { axiosCustom } from 'common/common.function';

/**
 * AI 채팅 로그 조회 입력
 */
export interface GetAiChatLogsInput {
  page?: number;
  limit?: number;
  startDate?: Date;
  endDate?: Date;
  userId?: number;
  sessionId?: string;
  isHighRisk?: boolean;
  username?: string;
}

/**
 * AI 채팅 로그 조회 출력
 */
export interface GetAiChatLogsOutput {
  success: boolean;
  error?: string;
  logs?: any[];
  count?: number;
  currentPage?: number;
  totalPages?: number;
}

/**
 * AI 채팅 통계 조회 입력
 */
export interface GetAiChatStatisticsInput {
  startDate: string;
  endDate: string;
}

/**
 * AI 채팅 통계 조회 출력
 */
export interface GetAiChatStatisticsOutput {
  success: boolean;
  error?: string;
  dailyStats?: {
    date: string;
    totalCalls: number;
    totalTokens: number;
    totalCost: number;
  }[];
}

/**
 * AI 채팅 로그 조회 API
 */
// AI Chat Logs
export const getAiChatLogs = async (params: GetAiChatLogsInput): Promise<GetAiChatLogsOutput> => {
  try {
    const data = await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/ai-logs`, { params });
    return data;
  } catch (error: any) {
    return {
      success: false,
      error: error.message,
    };
  }
};

// AI Chat Statistics
export const getAiChatStatistics = async (params: GetAiChatStatisticsInput): Promise<GetAiChatStatisticsOutput> => {
  try {
    const data = await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/ai-stats`, { params });
    return data;
  } catch (error: any) {
    return {
      success: false,
      error: error.message,
    };
  }
};

// Exchange Rate
export const getExchangeRate = async (): Promise<{ success: boolean; rate: number }> => {
  try {
    const data = await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/exchange-rate`);
    return data;
  } catch (error: any) {
    return {
      success: false,
      rate: 1450, // Fallback
    };
  }
};
